// IT-1465: Add limit for `slugs` as URLS have a maximum length
// NOTE: The URL limit is much larger (2053 characters), but still nice to have
// a sane limit in our app
// https://stackoverflow.com/a/417184
export const MAX_SLUG_LENGTH = 256

export const MIN_SLUG_LENGTH = 1

// IT-2872: Add limit for (practice/user) names
export const MAX_NAME_LENGTH = 500

// Limit for input fields (to avoid spam/large text blobs)
export const MAX_INPUT_LENGTH = 1000

// Centralized minimum password length (for frontend and backend validation)
export const MIN_PASSWORD_LENGTH = 8

// Limit for the `search` query param
export const MAX_QUERY_LENGTH = 1000

// Limit age to a reasonable value
export const MAX_AGE_LIMIT = 150

// IT-4867: Logo upload limits

/** Binary megabyte (MiB) — the unit upload size limits are expressed in. */
export const BYTES_PER_MEGABYTE = 1024 * 1024

export const PIXELS_PER_MEGAPIXEL = 1_000_000

/** Max accepted logo upload size in bytes (matches the "up to 10MB" UI copy). */
export const MAX_LOGO_FILE_SIZE_BYTES = 10 * BYTES_PER_MEGABYTE

/** Max accepted source-image resolution for a logo. */
export const MAX_LOGO_MEGAPIXELS = 25

/** Max length of a Dedalus-issued MicroHIS praktijkcode (`Practice.hisSettings.microHis.praktijkCode`). */
export const MICROHIS_PRAKTIJK_CODE_MAX_LENGTH = 32

/**
 * Max accepted `PhoneTemplate.scheduleCallbacksPerHour`. One call-back per minute is
 * already far beyond anything a practice schedules; the cap exists so the callback grid
 * generator cannot be handed a rate whose spacing (`3600 / rate` seconds) rounds down to
 * zero, which would make it try to build an unbounded list of options.
 */
export const MAX_CALLBACKS_PER_HOUR = 60
